module.exports = __webpack_public_path__ + "static/media/confirmed.9a929deb.svg";